import React from "react";

function UploadIcon() {
  return (
    <svg
      id="Upload_from_device"
      data-name="Upload from device"
      xmlns="http://www.w3.org/2000/svg"
      width="147.547"
      height="120.721"
      viewBox="0 0 147.547 120.721"
    >
      <path
        id="Path_18492"
        data-name="Path 18492"
        d="M101.813,171.307H38.1a10.071,10.071,0,0,1-10.06-10.06H98.46a3.353,3.353,0,1,0,0-6.707H28.04V80.767A10.071,10.071,0,0,1,38.1,70.707H145.407a10.071,10.071,0,0,1,10.06,10.06V119.33a3.353,3.353,0,1,0,6.707,0V80.767A16.785,16.785,0,0,0,145.407,64H38.1A16.785,16.785,0,0,0,21.333,80.767v80.48A16.785,16.785,0,0,0,38.1,178.014h63.714a3.353,3.353,0,1,0,0-6.707Z"
        transform="translate(-21.333 -64)"
        fill="#adbacf"
      />
      <path
        id="Path_18493"
        data-name="Path 18493"
        d="M185.557,141.771A6.371,6.371,0,0,0,176,147.288v39.5a6.357,6.357,0,0,0,9.557,5.518l34.2-19.748a6.371,6.371,0,0,0,0-11.035Zm-2.85,44.432V147.869l33.2,19.167Z"
        transform="translate(-127.376 -116.736)"
        fill="#adbacf"
      />
      <path
        id="Path_18494"
        data-name="Path 18494"
        d="M376.774,310.316a3.354,3.354,0,0,0-4.742,0l-8.383,8.383a3.353,3.353,0,1,0,4.742,4.742l2.659-2.659V336.16a3.353,3.353,0,1,0,6.707,0V320.783l2.659,2.659a3.353,3.353,0,1,0,4.742-4.742Z"
        transform="translate(-255.359 -232.207)"
        fill="#adbacf"
      />
      <path
        id="Path_18495"
        data-name="Path 18495"
        d="M337.837,266.667a28.5,28.5,0,1,0,28.5,28.5A28.5,28.5,0,0,0,337.837,266.667Zm0,50.3a21.8,21.8,0,1,1,21.8-21.8A21.8,21.8,0,0,1,337.837,316.967Z"
        transform="translate(-218.793 -202.953)"
        fill="#adbacf"
      />
    </svg>
  );
}

export default UploadIcon;
